import React, { Component } from "react";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import NotificationDescription from "../Notifications/NotificationDescription";
import { sections } from "./ugcSections";

const NAVY = "#1A2B4A";
const NAVY_2 = "#243B66";
const GOLD = "#C8991A";
const CRIMSON = "#B22222";
const INK = "#374151";
const BORDER = "#e8e0d0";

export const list = sections;

class UgcSelfDisclosure extends Component {
  state = {
    link: sections[0].link,
  };

  componentDidMount() {
    this.setState({
      link: this.resolveLink(this.props.match.params.link),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.link !== this.props.match.params.link) {
      this.setState({
        link: this.resolveLink(this.props.match.params.link),
      });
    }
  }

  // an unknown or missing section falls back to the first one
  resolveLink = (link) => {
    const found = sections.find((el) => el.link === link);
    return found ? found.link : sections[0].link;
  };

  go = (link) => {
    this.props.history.push(`/ugc-public-self-disclosure/${link}`);
  };

  open = (item) => {
    if (item.external) {
      window.open(item.path, "_blank");
    } else {
      this.props.history.push(item.path);
    }
  };

  render() {
    const active =
      sections.find((el) => el.link === this.state.link) || sections[0];

    const links = active.items.filter((el) => el.path);
    const docs = active.items.filter((el) => el.code);

    return (
      <div>
        <BreadCrumbOwn title="UGC Public Self-Disclosure" />

        <div className="ugc-page">
          <div className="ugc-page__inner">
            {/* SIDEBAR */}
            <aside className="ugc-side">
              <div className="ugc-side__header">
                <span className="ugc-side__eyebrow">
                  UGC Public Self-Disclosure
                </span>
                <span className="ugc-side__title">Sections</span>
              </div>

              <nav
                className="ugc-side__nav"
                aria-label="UGC Public Self-Disclosure sections"
              >
                {sections.map((el, index) => (
                  <button
                    type="button"
                    key={index}
                    onClick={() => this.go(el.link)}
                    className={`ugc-side__item${
                      el.link === this.state.link ? " is-active" : ""
                    }`}
                  >
                    <span className="ugc-side__num">{index + 1}</span>
                    <span>{el.title}</span>
                  </button>
                ))}
              </nav>
            </aside>

            {/* CONTENT */}
            <main className="ugc-content">
              <div className="ugc-content__intro">
                In compliance with the UGC guidelines on Public Self-Disclosure
                by Higher Education Institutions, Rangia College publishes the
                following institutional information for all stakeholders. Every
                item below is open to the public and needs no registration or
                login.
              </div>

              <h2 className="ugc-content__heading">{active.title}</h2>

              {links.length > 0 && (
                <div className="ugc-links">
                  {links.map((el, index) => (
                    <button
                      type="button"
                      key={index}
                      className="ugc-link"
                      onClick={() => this.open(el)}
                    >
                      <span className="ugc-link__text">{el.title}</span>
                      <span className="ugc-link__arrow">&rsaquo;</span>
                    </button>
                  ))}
                </div>
              )}

              {docs.map((el, index) => (
                <div className="ugc-docs" key={index}>
                  <NotificationDescription
                    key={el.code}
                    type="streategies"
                    code={el.code}
                    title={el.title}
                    noMinHeight={true}
                  />
                </div>
              ))}
            </main>
          </div>
        </div>

        <style>{`
          .ugc-page {
            background: #fff;
            padding: 32px 0 56px;
          }
          .ugc-page__inner {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
            display: grid;
            grid-template-columns: 300px 1fr;
            gap: 28px;
            align-items: start;
          }

          /* Sidebar */
          .ugc-side {
            background: #fff;
            border: 1px solid ${BORDER};
            border-radius: 10px;
            box-shadow: 0 4px 18px rgba(26,43,74,0.06);
            overflow: hidden;
            position: sticky;
            top: 16px;
            max-height: calc(100vh - 32px);
            display: flex;
            flex-direction: column;
            font-family: 'Lato', sans-serif;
          }
          .ugc-side__header {
            background: linear-gradient(135deg, ${NAVY} 0%, ${NAVY_2} 100%);
            color: #fff;
            padding: 18px 20px 16px;
            border-bottom: 3px solid ${GOLD};
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
          .ugc-side__eyebrow {
            color: ${GOLD};
            font-size: 10px;
            font-weight: 700;
            letter-spacing: 2px;
            text-transform: uppercase;
          }
          .ugc-side__title {
            font-family: 'Playfair Display', Georgia, serif;
            font-size: 18px;
            font-weight: 700;
            letter-spacing: 0.3px;
          }
          .ugc-side__nav {
            overflow-y: auto;
            padding: 6px 0;
            scrollbar-width: thin;
            scrollbar-color: ${GOLD} transparent;
          }
          .ugc-side__nav::-webkit-scrollbar { width: 6px; }
          .ugc-side__nav::-webkit-scrollbar-thumb {
            background: rgba(200,153,26,0.4);
            border-radius: 3px;
          }
          .ugc-side__item {
            width: 100%;
            text-align: left;
            background: transparent;
            border: none;
            border-left: 3px solid transparent;
            padding: 12px 16px 12px 15px;
            font-family: 'Lato', sans-serif;
            font-size: 13.5px;
            font-weight: 500;
            color: ${INK};
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 10px;
            transition: background 0.15s, color 0.15s, border-color 0.15s;
            line-height: 1.35;
          }
          .ugc-side__num {
            flex-shrink: 0;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: rgba(26,43,74,0.07);
            color: ${NAVY};
            font-size: 11px;
            font-weight: 700;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
          .ugc-side__item:hover {
            background: rgba(200,153,26,0.08);
            color: ${NAVY};
            border-left-color: ${GOLD};
          }
          .ugc-side__item.is-active {
            background: rgba(178,34,34,0.06);
            color: ${CRIMSON};
            border-left-color: ${CRIMSON};
            font-weight: 700;
          }
          .ugc-side__item.is-active .ugc-side__num {
            background: ${CRIMSON};
            color: #fff;
          }

          /* Content */
          .ugc-content {
            background: #fff;
            min-width: 0;
            font-family: 'Lato', sans-serif;
            color: ${INK};
          }
          .ugc-content__intro {
            border: 1px solid ${BORDER};
            border-left: 4px solid ${GOLD};
            border-radius: 8px;
            background: #f7f6f2;
            padding: 14px 18px;
            font-size: 13.5px;
            line-height: 1.6;
          }
          .ugc-content__heading {
            font-family: 'Playfair Display', Georgia, serif;
            font-size: 26px;
            font-weight: 700;
            color: ${NAVY};
            margin: 24px 0 14px;
          }
          .ugc-links {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 10px;
            margin-bottom: 8px;
          }
          .ugc-link {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            text-align: left;
            background: #fff;
            border: 1px solid ${BORDER};
            border-left: 3px solid ${GOLD};
            border-radius: 8px;
            padding: 12px 14px;
            font-family: 'Lato', sans-serif;
            font-size: 13.5px;
            font-weight: 600;
            color: ${NAVY};
            cursor: pointer;
            transition: box-shadow 0.15s, transform 0.15s, border-color 0.15s;
          }
          .ugc-link:hover {
            box-shadow: 0 6px 18px rgba(26,43,74,0.10);
            transform: translateY(-1px);
            border-left-color: ${CRIMSON};
          }
          .ugc-link__arrow {
            color: ${GOLD};
            font-size: 20px;
            line-height: 1;
          }
          .ugc-docs {
            margin-top: 8px;
          }
          /* the shared document list ships its own container padding */
          .ugc-docs .container {
            padding-left: 0;
            padding-right: 0;
            max-width: 100%;
          }

          @media (max-width: 960px) {
            .ugc-page__inner {
              grid-template-columns: 1fr;
            }
            .ugc-side {
              position: relative;
              top: 0;
              max-height: none;
            }
            .ugc-side__nav {
              max-height: 320px;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default UgcSelfDisclosure;
